import React, { useState, useEffect } from "react";
import Grid from "@mui/material/Unstable_Grid2";
import { Breadcrumb } from "../../../components";
import { CardHeader } from "../../../components/cards";
import {Box} from "../../../components/elements";
import PageLayout from "../../../layouts/PageLayout";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import { Button as MuiButton } from '@mui/material';
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";

export default function AddTab() {
  const navigate = useNavigate();
  const token = localStorage.getItem("token");

  const [storehouses, setStorehouses] = useState([]);
  const [tab, setTab] = useState({
    storehouse: "",
    index: "",
    name: ""
  });

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_BASE_URL}common/storehouses`, {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(({ data }) => setStorehouses(data))
      .catch(console.error);
  }, []);

  const addTab = async () => {
    const { storehouse, index, name } = tab;
    if (!storehouse || !index || !name) {
      alert("Please select Storehouse, and fill Tab Index & Name.");
      return;
    }
    try {
      await axios.post(
        `${process.env.REACT_APP_BASE_URL}common/tabs`,
        tab,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      alert("Tab created successfully!");
      navigate("/tab-list");
    } catch (e) {
      console.error(e);
      alert(e.response?.data?.message || "Error creating tab.");
    }
  };

  return (
    <PageLayout>
      <Grid container spacing={2} className="align-items-center mb-3">
        <Grid size={{ xs: 12, md: 6 }}>
          <Breadcrumb title="Add Tab" />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }} className="text-end">
          <Link to="/tab-list">
            <MuiButton variant="contained" color="secondary">Back to List</MuiButton>
          </Link>
        </Grid>
      </Grid>

      <Box className="mc-card">
        <Grid container spacing={2}>
          {/* Storehouse */}
          <Grid size={{ xs: 12 }} className="mb-3">
            <CardHeader title="Storehouse" />
            <TextField
              select
              fullWidth
              value={tab.storehouse}
              onChange={e =>
                setTab({ ...tab, storehouse: e.target.value })
              }
            >
              {storehouses.map(sh => (
                <MenuItem key={sh._id} value={sh._id}>
                  {sh.code} {sh.name && `– ${sh.name}`}
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          {/* Tab Index */}
          <Grid size={{ xs: 12 }} className="mb-3">
            <CardHeader title="Tab Index" />
            <TextField
              type="number"
              fullWidth
              placeholder="1–4"
              value={tab.index}
              onChange={e =>
                setTab({ ...tab, index: e.target.value })
              }
            />
          </Grid>

          {/* Tab Name */}
          <Grid size={{ xs: 12 }} className="mb-3">
            <CardHeader title="Tab Name" />
            <TextField
              fullWidth
              placeholder="e.g. Electrical Supplies"
              value={tab.name}
              onChange={e =>
                setTab({ ...tab, name: e.target.value })
              }
            />
          </Grid>
        </Grid>

        <Grid container spacing={2} className="mt-3">
          <Grid size={{ xs: 12 }} className="text-end">
            <MuiButton variant="contained" color="primary" onClick={addTab}>
              Create Tab
            </MuiButton>
          </Grid>
        </Grid>
      </Box>
    </PageLayout>
  );
}
